import type { AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import type { QueryArgs } from './types'

export type CustomRequestInterceptor = (
  args: QueryArgs,
) => (
  value: InternalAxiosRequestConfig,
) => InternalAxiosRequestConfig | Promise<InternalAxiosRequestConfig>

export type CustomResponseInterceptor = (
  args: QueryArgs,
) => (value: AxiosResponse) => AxiosResponse | Promise<AxiosResponse>

export const createRequestInterceptor = (interceptor: CustomRequestInterceptor) => interceptor
export const createResponseInterceptor = (interceptor: CustomResponseInterceptor) => interceptor
